import { createSlice } from "@reduxjs/toolkit";
import { CertificateInterface } from "../../common/interfaces/CertificateInterface";

interface RejectCertificateModalInterface {
    isRejectCertificateModalOpen: boolean;
    formValues?: {
        comment: string;
    };
    selectedCertificate?: CertificateInterface;
}

const initialState: RejectCertificateModalInterface = {
    isRejectCertificateModalOpen: false,
};

const rejectCertificateModalSlice = createSlice({
    name: "rejectCertificateModal",
    initialState,
    reducers: {
        setIsRejectCertificateModalOpen: (state, action) => {
            state.isRejectCertificateModalOpen = action.payload;
        },
        setFormValues: (state, action) => {
            state.formValues = action.payload;
        },
        setSelectedCertificate: (state, action) => {
            state.selectedCertificate = action.payload;
        },
    },
});

export const rejectCertificateModalReducer =
    rejectCertificateModalSlice.reducer;

export const {
    setIsRejectCertificateModalOpen,
    setFormValues,
    setSelectedCertificate,
} = rejectCertificateModalSlice.actions;
